<template>
    <div class="row">
        <div class="col-md-12">
            <div class="panel panel-stretch panel-default">
                <div class="panel-heading"><i class="mdi mdi-map-marker"></i>
                    {{ editCustomerPropertyTitle }}
                </div>
                <div class="panel-body">
                    <PropertyShowComponent v-if="hasCustomerProperty"
                                           :property-object="customerProperty.property.data"
                                           :compact-toggleable="true"
                                           :compact="false"
                                           :edit="false"
                                           v-bind:show-title="false"></PropertyShowComponent>
                    <CustomerPropertyShowComponent v-if="hasCustomerProperty"
                                                   v-bind:customer-property="customerProperty"></CustomerPropertyShowComponent>
                    <div class="text-right">
                        <a-button type="primary" v-on:click="handleToEdit">
                            <pencil-icon></pencil-icon>
                            Bewerken
                        </a-button>
                      <a-popconfirm
                          placement="topRight"
                          title="Weet je zeker dat je dit adres wil verwijderen?"
                          ok-text="Verwijderen"
                          cancel-text="Annuleren"
                          @confirm="handleDelete"
                      >
                        <a-button type="danger">
                          <delete-icon></delete-icon>
                          Verwijderen
                        </a-button>
                      </a-popconfirm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import propertyApi from "~/api/property";
import customerPropertyApi from "~/api/customer_property";
import CustomerPropertyShowComponent from './ShowComponent'
import PropertyShowComponent from '~/modules/property/components/ShowComponent'

export default {
    name: "CustomerPropertyShowPageComponent",
    components: {
        CustomerPropertyShowComponent,
        PropertyShowComponent
    },
    props: {
        customerPropertyId: {
            required: true,
        },
    },
    data() {
        return {
            customerProperty: null,
            form: this.$form.createForm(this),
            address_type: {
                mail: 'Postadres',
                visit: 'Bezoekadres',
                establishment: 'Vestiging',
            },
            updateCustomerPropertyLoading: false,
        };
    },
    computed: {
        property() {
            if (typeof this.customerProperty === "undefined" || typeof this.customerProperty.property === "undefined") {
                return {};
            }

            return this.customerProperty.property.data;
        },
        hasCustomerProperty() {
            return this.customerProperty !== null;
        },
        editCustomerPropertyTitle() {
            if (typeof this.customerProperty !== "undefined" && this.customerProperty !== null) {
                return this.customerProperty.property.data.formatted_address + ' - ' + this.getAddressType;
            }
            return '';
        },
      getAddressType() {
        if(this.customerProperty.address_type) {
          return this.address_type[this.customerProperty.address_type];
        }
        return 'Onbekend adrestype'
      }
    },
    mounted() {
        customerPropertyApi.getById(this.customerPropertyId, ['customer', 'property', 'property.country']).then(response => {
            this.customerProperty = response.data;
        });
    },
    methods: {
        handleToEdit() {
          window.location.href = '/customer/' + this.customerProperty.customer_id + '/property/' + this.customerProperty.id + '/edit';
        },
      handleDelete() {
        customerPropertyApi.delete(this.customerProperty.id).then(response => {
          window.location.href = '/customer/' + this.customerProperty.customer_id + '/property/';
        }).catch();
      }
    }
}
</script>
<style scoped>
</style>
